import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { fmtDate, fmtHours, monthRange } from '../utils/helpers';

export default function Dashboard({ onNavigate }) {
  const [iReport,  setIReport]  = useState(null);
  const [pReport,  setPReport]  = useState(null);
  const [sqReport, setSqReport] = useState(null);
  const [recent,   setRecent]   = useState([]);

  useEffect(() => {
    const r = monthRange();
    api.reports.instructorTime(r).then(setIReport).catch(() => {});
    api.reports.pilotTime(r).then(setPReport).catch(() => {});
    api.reports.squawk({ status: 'open' }).then(setSqReport).catch(() => {});
    api.sessions.list({ from: r.from, to: r.to }).then(rows => setRecent(rows.slice(0, 8))).catch(() => {});
  }, []);

  const totalHours   = iReport?.summary?.reduce((a, r) => a + (r.total_sim_hours || 0), 0) || 0;
  const sessionCount = iReport?.summary?.reduce((a, r) => a + (r.session_count || 0), 0) || 0;
  const pilotCount   = (pReport?.pic_summary?.length || 0);
  const openSquawks  = sqReport?.stats?.open || 0;

  return (
    <div>
      <div className="section-title">Dashboard</div>
      <p className="section-subtitle">
        This month — {new Date().toLocaleString('default', { month: 'long', year: 'numeric' })}
      </p>

      <div className="stat-grid">
        <div className="stat-card">
          <div className="stat-value">{sessionCount}</div>
          <div className="stat-label">Sessions This Month</div>
        </div>
        <div className="stat-card gold">
          <div className="stat-value">{fmtHours(totalHours)}</div>
          <div className="stat-label">Total Sim Hours</div>
        </div>
        <div className="stat-card blue">
          <div className="stat-value">{pilotCount}</div>
          <div className="stat-label">Active Pilots (PIC)</div>
        </div>
        <div className="stat-card red">
          <div className="stat-value">{openSquawks}</div>
          <div className="stat-label">Open Squawks</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>Recent Sessions</h2>
          <p>Last 8 sessions this month</p>
        </div>
        <div className="card-body" style={{ padding: 0 }}>
          {recent.length === 0 ? (
            <div className="empty"><div className="empty-icon">📋</div>No sessions logged this month</div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Instructor</th>
                    <th>PIC</th>
                    <th>Training Type</th>
                    <th>Sim Hrs</th>
                    <th>Squawk</th>
                  </tr>
                </thead>
                <tbody>
                  {recent.map(s => (
                    <tr key={s.id}>
                      <td>{fmtDate(s.date)}</td>
                      <td>{s.instructor_name}</td>
                      <td>{s.pic_name || <span style={{color:'#aaa'}}>—</span>}</td>
                      <td><span className="badge badge-type">{s.training_type}</span></td>
                      <td>{fmtHours(s.sim_time)}</td>
                      <td>
                        {s.squawk
                          ? (() => {
                              const map = { open: ['badge-open','Open'], in_progress: ['badge-progress','In Progress'], resolved: ['badge-resolved','Resolved'] };
                              const [cls, label] = map[s.squawk_status] || ['badge-open','Open'];
                              return <span className={`badge ${cls}`}>{label}</span>;
                            })()
                          : <span style={{color:'#aaa'}}>—</span>
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
        <button className="btn btn-primary" onClick={() => onNavigate('log')}>+ Log New Session</button>
        <button className="btn btn-secondary" onClick={() => onNavigate('report-sqk')}>View Open Squawks</button>
      </div>
    </div>
  );
}
